exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".overlay.options{position:absolute;right:0;opacity:.5;margin-right:10px;color:#fff;padding:5px 20px;transition:opacity .25s ease-in-out,height .5s ease-in-out;-moz-transition:opacity .25s ease-in-out,height .5s ease-in-out;-webkit-transition:opacity .25s ease-in-out,height .5s ease-in-out;width:200px;overflow:hidden;height:50px}.overlay.options:hover{opacity:1}.overlay.options.toggle{height:20px}.overlay.options .row{border-bottom:1px solid hsla(0,0%,100%,.5);padding-top:5px}.overlay.options .two-column{width:50%;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./app/styles/threejsPlanet.scss
// module id = 16
// module chunks = 0